import {z} from "zod";

export const pagoMovilAccountSchema = z.object({
  bankCode: z.string().trim().min(3, "Selecciona un banco").regex(/^\d+$/, "Código de banco inválido"),
  phoneNumber: z
    .string()
    .trim()
    .regex(/^\d+$/, "Solo números")
    .min(10, "El teléfono debe tener al menos 10 dígitos")
    .max(11, "El teléfono no puede tener más de 11 dígitos"),
});

export type PagoMovilAccountFormInput = z.input<typeof pagoMovilAccountSchema>;
export type PagoMovilAccountFormValues = z.output<typeof pagoMovilAccountSchema>;
